<div class="page-chat content-layout" fxLayout="column">

    <calsoft-page-header [height]="'160px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>


    <div class="container" fxFlex fxLayout="column">

        <calsoft-breadcrumbs [url]="productId==0?'product,Add Product':'product,Edit Product'"
            [currentPage]="productId==0?'Products,Add Product':'Products,Edit Product'" [header]="'primary'">
        </calsoft-breadcrumbs>


        <div *ngIf="!productadd && productId ==  0" fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-edit-product-btn-1' + '__' + sanitizedUrl" (click)="back()"
                                matTooltip="Back" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button> {{title}}
                        </div>
                    </div>
                    <div class="content" fxLayout="column">
                        <div class="result" fxLayout="column">
                            <div class="container">
                                <div id="content">
                                    <div class="products-padding">
                                        <div class="editSets" [formGroup]="firstFormGroup">
                                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                                <span>Create Product Settings
                                                </span>
                                            </div>
                                            <div class="products-padding">
                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px">
                                                    <!-- <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Attribute Set</mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="attributeSet">
                                                            <mat-option
                                                                *ngFor="let item of attributeSetList; let i=index;"
                                                                [value]="item.attributeSetId">
                                                                {{item.attributeSetName}}
                                                            </mat-option>
                                                        </mat-select>

                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.attributeSet">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>

                                                    </mat-form-field> -->


                                                    <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Attribute Set</mat-label>
                                                        <mat-select formControlName="attributeSet"
                                                            [disableOptionCentering]="true" required #singleSelect>
                                                            <mat-option>
                                                                <ngx-mat-select-search name="Attribute Search"
                                                                    ngDefaultControl
                                                                    [formControl]="attributeFilterControl"
                                                                    placeholderLabel="Attribute Search"
                                                                    [preventHomeEndKeyPropagation]="true"
                                                                    noEntriesFoundLabel="No data found">
                                                                </ngx-mat-select-search>
                                                            </mat-option>
                                                            <mat-option
                                                                *ngFor="let item of filteredAttributeList; let i=index;"
                                                                [value]="item.attributeSetId">
                                                                {{item.attributeSetName}}
                                                            </mat-option>
                                                        </mat-select>
                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.attributeSet">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('attributeSet').hasError(validation.type) && (firstFormGroup.get('attributeSet').dirty || firstFormGroup.get('attributeSet').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>
                                                    </mat-form-field>

                                                    <mat-form-field fxFlex appearance="outline"
                                                        *ngIf="productRestriction">
                                                        <mat-label>Product Type</mat-label>
                                                        <mat-select required [disableOptionCentering]="true"
                                                            formControlName="type">
                                                            <mat-option *ngFor="let item of productType1"
                                                                [value]="item">
                                                                {{item}}
                                                            </mat-option>
                                                        </mat-select>

                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.type">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('type').hasError(validation.type) && (firstFormGroup.get('type').dirty || firstFormGroup.get('type').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>
                                                    </mat-form-field>

                                                    <mat-form-field fxFlex appearance="outline"
                                                        *ngIf="!productRestriction">
                                                        <mat-label>Product Type</mat-label>
                                                        <mat-select required [disableOptionCentering]="true"
                                                            formControlName="type">
                                                            <mat-option *ngFor="let item of productType" [value]="item">
                                                                {{item}}
                                                            </mat-option>
                                                        </mat-select>

                                                        <mat-error
                                                            *ngFor="let validation of createAttributeValidations.type">
                                                            <mat-error class="error-message"
                                                                *ngIf="firstFormGroup.get('type').hasError(validation.type) && (firstFormGroup.get('type').dirty || firstFormGroup.get('type').touched) ">
                                                                {{validation.message}}
                                                            </mat-error>
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="btn" fxLayoutAlign="end center">
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-2' + '__' + sanitizedUrl"
                                                    [disabled]="textAdd !='Create'" (click)="getAttributeGroup()"
                                                    mat-raised-button>
                                                    {{textAdd}}
                                                    <mat-icon *ngIf="textAdd !='Create' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>



                                    <!-- <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
                      <button [attr.guide]="'add-edit-product-btn-3' + '__' + sanitizedUrl" mat-raised-button>Cancel</button>
                      <button [attr.guide]="'add-edit-product-btn-4' + '__' + sanitizedUrl" mat-raised-button >Create</button>
                    </div> -->
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card" fxFlex fxLayout="column">
            <mat-drawer-container *ngIf="productadd">

                <mat-drawer [mode]="mobileQuery.matches ? 'over' : 'side'" (openedChange)="drawerChange($event)"
                    [opened]="drawerOpen$ | async" class="mat-elevation-z1 drawer" position="start">

                    <div class="sidenav-container" fxFlex fxLayout="column">
                        <div class="chat-toolbar " fxLayout="row" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-edit-product-btn-5' + '__' + sanitizedUrl" fxHide
                                fxShow.gt-md fxShow.gt-sm matTooltip="Back" (click)="back()" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            <span fxHide fxShow.gt-md fxShow.gt-sm>{{title}}</span>
                            <span fxHide fxShow.lt-md fxShow.lt-sm>Select a Tab</span>
                            <span fxFlex>
                            </span>

                        </div>
                        <div class="flex-auto overflow-hidden">
                            <calsoft-scrollbar class="flex-auto">

                                <mat-nav-list class="chat-contacts">
                                    <mat-list-item class="chat-contact" (click)="get(item.attributeGroupName,i,item)"
                                        *ngFor="let item of regConfig; let i = index"
                                        [class.highlighted]="item.attributeGroupName == groupName "
                                        isMatnavlistOpen=false; class="nav-list">

                                        <div fxLayoutAlign="start center" fxLayoutGap="20px">
                                            <a matLinevalue="menu">
                                                {{ item.attributeGroupName }}
                                            </a>

                                            <div
                                                *ngIf="item.attributeGroupName=='Categories'&&(this.form.controls.catalogCategoryProduct.status=='INVALID');">


                                                <mat-icon class="danger">
                                                    error_outline</mat-icon>
                                            </div>

                                            <div
                                                *ngIf="item.attributeGroupName=='Categories'&&(this.form.controls.catalogCategoryProduct.status!='INVALID');">


                                                <mat-icon class="success">
                                                    check_circle_outline</mat-icon>
                                            </div>

                                            <div *ngIf="!bookingEnabled">



                                                <div *ngIf="item.attributeGroupName=='Inventory'
                                                &&(this.form.controls.catalogInventoryStockItem.status=='INVALID');">


                                                    <mat-icon class="danger">
                                                        error_outline</mat-icon>
                                                </div>

                                                <div
                                                    *ngIf="item.attributeGroupName=='Inventory'&&(this.form.controls.catalogInventoryStockItem.status!='INVALID');">


                                                    <mat-icon class="success">
                                                        check_circle_outline</mat-icon>
                                                </div>

                                            </div>

                                            <div
                                                *ngIf="invalidMap.get(i) ==undefined&&item.attributeGroupName!='Categories'&&item.attributeGroupName!='Inventory'&&item.attributeGroupName!='Course';">
                                                <mat-icon class="success">
                                                    check_circle_outline</mat-icon>
                                            </div>

                                            <div *ngIf="item.attributeGroupName=='Course'
                                            &&(this.form.controls.course.status=='INVALID');">


                                                <mat-icon class="danger">
                                                    error_outline</mat-icon>
                                            </div>

                                            <div
                                                *ngIf="item.attributeGroupName=='Course'&&(this.form.controls.course.status!='INVALID');">


                                                <mat-icon class="success">
                                                    check_circle_outline</mat-icon>
                                            </div>

                                            <div *ngIf="invalidMap.get(i) !=undefined">

                                                <div *ngIf="checkValidataion(i); else elseBlock">

                                                    <mat-icon class="danger">
                                                        error_outline</mat-icon>
                                                </div>
                                                <ng-template #elseBlock>
                                                    <mat-icon class="success">
                                                        check_circle_outline</mat-icon>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </mat-nav-list>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer>
                <mat-drawer-content>
                    <div class="chat-inner-container" fxLayout="column">
                        <div class="chat-toolbar" fxLayout="row" fxLayoutAlign="start center">

                            <button [attr.guide]="'add-edit-product-btn-6' + '__' + sanitizedUrl" fxHide
                                fxShow.lt-md type="button" mat-icon-button (click)="openDrawer()">
                                <mat-icon>menu</mat-icon>
                            </button>

                            <div class="current-contact" fxLayout="row" fxLayoutAlign="start center">


                                <div fxLayout="column" fxLayoutAlign="center">

                                    <span class="status"></span>
                                </div>
                            </div>

                            <span fxFlex>
                            </span>
                            <div fxLayout="row" fxLayoutGap="10px">
                                <button [attr.guide]="'add-edit-product-btn-7' + '__' + sanitizedUrl"
                                    mat-icon-button *ngIf="productId != 0" (click)="audit('table')">
                                    <mat-icon>calendar_today</mat-icon>
                                </button>

                                <ng-container>
                                    <button [attr.guide]="'add-edit-product-btn-8' + '__' + sanitizedUrl"
                                        mat-raised-button *ngIf="productId !=
                                    0&&(!productConfigurable)" (click)="duplicate()">
                                        Duplicate
                                    </button>

                                </ng-container>



                                <button [attr.guide]="'add-edit-product-btn-9' + '__' + sanitizedUrl"
                                    [disabled]="text !='Save'" (click)="addOrEditProduct()" mat-raised-button>
                                    {{text}}
                                    <mat-icon *ngIf="text !='Save' ">
                                        <mat-spinner color="primary" diameter="20">
                                        </mat-spinner>
                                    </mat-icon>
                                </button>

                            </div>

                        </div>

                        <div class="flex-auto overflow-hidden">
                            <calsoft-scrollbar #tabsContentRef class="p-4  flex-auto">
                                <ng-container *ngIf="regConfig?.length > 0">
                                    <div *ngIf="groupName!='Categories' && groupName!='Inventory' 
                                    && groupName!='Recurring Profile'
                                    && groupName!='Design'
                                    && groupName!='Gift Options'
                                    && groupName!='Variants'
                                    && groupName!='Booking'
                                    && groupName!='Course'
                                    && groupName!='Variants Subscription'
                  && groupName !='Images'&& groupName!='Configurations' && groupName !='Images'&& groupName!='Configurations' 
                  && groupName !='Related Products'&& groupName!='Up-Sells' && groupName !='Cross-Sells'
                  ">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>{{groupName}}</span>
                                            </div>
                                            <div class="result" fxLayout="column">
                                                <ng-container *ngFor="let field of regConfig[defalutValue]
                                                    ['eavEntityAttribute'];" dynamicField
                                                    (submit)="onFormSubmitted($event)" [field]="field['eavAttribute']"
                                                    [data]="data" [group]="form">
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>



                                    <div *ngIf="!bookingEnabled">

                                        <div *ngIf="groupName =='Inventory'" [formGroup]="form">
                                            <div class="editSets1">
                                                <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                    <span>Inventory</span>
                                                </div>
                                                <div class="products-padding" fxLayout="column">

                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Is in Stock</mat-label>
                                                                <mat-select [disableOptionCentering]="true"
                                                                    formControlName="isInStock" required>
                                                                    <mat-option *ngFor="let status of booleanField"
                                                                        [value]="status.value">
                                                                        {{status.viewValue}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error>
                                                                    Please fill out this field.
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>

                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Manage Stock</mat-label>
                                                                <mat-select [disableOptionCentering]="true"
                                                                    formControlName="manageStock" required>
                                                                    <mat-option *ngFor="let status of booleanField"
                                                                        [value]="status.value">
                                                                        {{status.viewValue}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error>
                                                                    Please fill out this field.
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>

                                                    </div>

                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Qty</mat-label>
                                                                <input
                                                                    [attr.guide]="'add-edit-product-inp-qty' + '__' + sanitizedUrl"
                                                                    [readonly]="updateStockByPurchaseOnly"
                                                                    [disabled]="updateStockByPurchaseOnly"
                                                                    [autocomplete]="'off'" min="0" trim="blur"
                                                                    numbersOnly matInput required
                                                                    formControlName="qty" />
                                                                <mat-error
                                                                    *ngIf="form['controls'].catalogInventoryStockItem['controls'].qty.errors?.required">
                                                                    Please fill out this field.
                                                                </mat-error>
                                                                <mat-hint *ngIf="updateStockByPurchaseOnly">Can Update
                                                                    Stock
                                                                    Through Purchase Only</mat-hint>
                                                            </mat-form-field>

                                                        </div>
                                                    </div>

                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Minimum Quantity Allowed in Shopping Cart
                                                                </mat-label>
                                                                <input
                                                                    [attr.guide]="'add-edit-product-inp-minsaleqty' + '__' + sanitizedUrl"
                                                                    trim="blur" [autocomplete]="'off'" min="0"
                                                                    numbersOnly matInput required
                                                                    formControlName="minSaleQty" />
                                                                <mat-error
                                                                    *ngIf="form['controls'].catalogInventoryStockItem['controls'].minSaleQty.errors?.required">
                                                                    Please fill out this field.</mat-error>
                                                            </mat-form-field>

                                                        </div>
                                                    </div>
                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Maximum Quantity Allowed in Shopping Cart
                                                                </mat-label>
                                                                <input
                                                                    [attr.guide]="'add-edit-product-inp-maxqty' + '__' + sanitizedUrl"
                                                                    trim="blur" [autocomplete]="'off'" min="0"
                                                                    numbersOnly matInput required
                                                                    formControlName="maxQty" />
                                                                <mat-error
                                                                    *ngIf="form['controls'].catalogInventoryStockItem['controls'].maxQty.errors?.required">
                                                                    Please fill out this field.</mat-error>
                                                            </mat-form-field>

                                                        </div>
                                                    </div>

                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>

                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Notify For Qty Below</mat-label>
                                                                <input
                                                                    [attr.guide]="'add-edit-product-inp-notifystockqty' + '__' + sanitizedUrl"
                                                                    trim="blur" [autocomplete]="'off'" min="0"
                                                                    numbersOnly matInput required
                                                                    formControlName="notifyStockQty" />
                                                                <mat-error
                                                                    *ngIf="form['controls'].catalogInventoryStockItem['controls'].notifyStockQty.errors?.required">
                                                                    Please fill out this field.</mat-error>
                                                            </mat-form-field>

                                                        </div>
                                                    </div>
                                                    <div fxLayout="column" formGroupName="catalogInventoryStockItem">
                                                        <div fxFlex="50" fxFlex.lt-md>
                                                            <mat-form-field fxLayout="column" fxFlex="50" fxFlex.lt-md
                                                                appearance="outline">
                                                                <mat-label>Enable Qty Increment</mat-label>
                                                                <mat-select [disableOptionCentering]="true"
                                                                    formControlName="enableQtyIncrements" required>
                                                                    <mat-option *ngFor="let status of booleanField"
                                                                        [value]="status.value">
                                                                        {{status.viewValue}}
                                                                    </mat-option>
                                                                </mat-select>
                                                                <mat-error>
                                                                    Please fill out this field.ed
                                                                </mat-error>
                                                            </mat-form-field>
                                                        </div>

                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- inventory -->

                                    <!--End of inventory -->

                                    <!-- Configurations -->
                                    <div *ngIf="groupName =='Configurations'">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>Configurations</span>
                                            </div>
                                            <div class="products-padding" fxLayout="column">

                                                <div fxLayout="column" fxLayout.gt-sm="row"
                                                    fxLayoutAlign="space-between center">
                                                    <p fxFlex>
                                                        Configurable products allow customers to choose options (Ex:
                                                        shirt color).
                                                        You need to create a simple product for each configuration (Ex:
                                                        a product for each color).
                                                    </p>

                                                    <button
                                                        [attr.guide]="'add-edit-product-btn-10' + '__' + sanitizedUrl"
                                                        fxFlex="40" mat-raised-button
                                                        *ngIf="(form.value.catalogProductSuperLink?.length || 0) == 0"
                                                        (click)="getConfig()">
                                                        Create Configurations
                                                    </button>
                                                </div>

                                                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center"
                                                    *ngIf="(form.value.catalogProductSuperLink?.length || 0) > 0">

                                                    <div id="attribute" fxFlex="100">

                                                        <div class="padding-11" style="overflow-x: auto;">
                                                            <div class="editSets" fxLayout="column">


                                                                <div id="responsieTable" class="container">
                                                                    <div
                                                                        [ngClass]="(form.value.catalogProductSuperLink?.length || 0) >= 5 ? 'minimum' : 'none'">
                                                                        <table class="rwd-table">
                                                                            <tbody class="padding-10">
                                                                                <tr>

                                                                                    <th>Name</th>
                                                                                    <th>SKU</th>
                                                                                    <th>Maintain Stock Separately</th>
                                                                                    <th>Manage Price Separately</th>
                                                                                    <th>Manage Image Separately</th>
                                                                                    <th>Manage Description Separately
                                                                                    </th>
                                                                                    <th>Manage Additional Information
                                                                                        Separately</th>
                                                                                    <th>Manage Name
                                                                                        Separately</th>

                                                                                    <th>Action</th>

                                                                                </tr>


                                                                                <tr
                                                                                    *ngFor="let associatedProductObject of form.value.catalogProductSuperLink;let i=index">

                                                                                    <td data-th="name">
                                                                                        {{associatedProductObject.name |
                                                                                        slice:0:40}}
                                                                                    </td>
                                                                                    <td data-th="sku">
                                                                                        {{associatedProductObject.sku }}
                                                                                    </td>
                                                                                    <td data-th="M-Stock">
                                                                                        {{associatedProductObject.manageStockSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="M-Price">
                                                                                        {{associatedProductObject.managePriceSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="M-Image">
                                                                                        {{associatedProductObject.manageImageSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="M-Description">
                                                                                        {{associatedProductObject.manageDescriptionSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="M-Image">
                                                                                        {{associatedProductObject.manageAdditionalInformationSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="M-Image">
                                                                                        {{associatedProductObject.manageNameSeperately
                                                                                        }}
                                                                                    </td>
                                                                                    <td data-th="Action">
                                                                                        <button
                                                                                            [attr.guide]="'add-edit-product-btn-11' + '__' + sanitizedUrl"
                                                                                            mat-icon-button color="warn"
                                                                                            (click)="removeAssociatedProduct(i,associatedProductObject.linkId)">
                                                                                            <mat-icon>
                                                                                                remove
                                                                                            </mat-icon>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <div fxLayout="row" class="products-padding"
                                                                            *ngIf="(form.value.catalogProductSuperLink?.length || 0) == 0"
                                                                            fxLayoutAlign="center center">
                                                                            <span>No Records Found</span>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>


                                    <div *ngIf="groupName =='Variants'" [formGroup]="form">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                                <span>Variants</span>
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-12' + '__' + sanitizedUrl"
                                                    mat-icon-button>
                                                    <mat-icon (click)="addVarient()">
                                                        add
                                                    </mat-icon>
                                                </button>
                                            </div>
                                            <div class="products-padding" fxLayout="column">



                                                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">

                                                    <div id="attribute" fxFlex="100">

                                                        <div class="padding-11" fxFlex="100" style="overflow-x: auto;">
                                                            <div fxFlex="100" class="editSets" fxLayout="column">

                                                                <div fxFlex="100" id="responsieTable" class="container"
                                                                    style="overflow-x:auto;">
                                                                    <div>
                                                                        <table fxFlex="100" class="rwd-table">
                                                                            <tbody fxFlex="100"
                                                                                formArrayName="varientProductItems">
                                                                                <tr>
                                                                                    <th fxFlex="10">Variants</th>
                                                                                    <th fxFlex="8">Price</th>
                                                                                    <th fxFlex="8">Special Price</th>
                                                                                    <th fxFlex="10">Sku</th>
                                                                                    <th fxFlex="20"
                                                                                        *ngIf="b2bPricingEnabled">Whole
                                                                                        Sale Price
                                                                                    </th>
                                                                                    <th fxFlex="20"
                                                                                        *ngIf="b2bPricingEnabled">Whole
                                                                                        Sale Discount
                                                                                        Price</th>
                                                                                    <th fxFlex="5">Min Qty</th>
                                                                                    <th fxFlex="5">Max Qty</th>
                                                                                    <th fxFlex="10">Weight</th>
                                                                                    <th fxFlex="10">Stock</th>
                                                                                    <th fxFlex="10">qty</th>
                                                                                    <th fxFlex="15">Images</th>
                                                                                </tr>
                                                                                <ng-container *ngFor="let object of  
                                                                      form.get('varientProductItems')
                                                                      ['controls']; let i=index" [formGroupName]="i">
                                                                                    <tr fxLayout.xs="column">
                                                                                        <td data-th="Variant Name"
                                                                                            fxFlex="10"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Varient
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-varientname' + '__' + sanitizedUrl"
                                                                                                    readonly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="varientName" />

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="price"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-price' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="price" />

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8"
                                                                                            data-th="Special Price"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Special Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-specialprice' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="specialPrice" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="SKU"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Sku
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-skuid' + '__' + sanitizedUrl"
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="skuId" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="SKU"
                                                                                            *ngIf="b2bPricingEnabled"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Whole Sale
                                                                                                    Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-wholesaleprice' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="wholeSalePrice" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="SKU"
                                                                                            *ngIf="b2bPricingEnabled"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Whole Sale
                                                                                                    Discount Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-wholesalespecialprice' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="wholeSaleSpecialPrice" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="SKU"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Min
                                                                                                    Qty</mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-minqty' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="minQty" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="SKU"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Max
                                                                                                    Qty</mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-maxqty' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="maxQty" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="Weight"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Weight
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-weight' + '__' + sanitizedUrl"
                                                                                                    numbersOnly required
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="weight" />
                                                                                                <mat-error
                                                                                                    *ngIf="weightFormControl.hasError('required')">
                                                                                                    Weight
                                                                                                    is
                                                                                                    required</mat-error>
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="10" data-th="Stock"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field
                                                                                                fxLayout="column"
                                                                                                fxFlex="100"
                                                                                                fxFlex.lt-md
                                                                                                appearance="outline">
                                                                                                <mat-label>Is in
                                                                                                    Stock</mat-label>
                                                                                                <mat-select
                                                                                                    [disableOptionCentering]="true"
                                                                                                    formControlName="isInStock"
                                                                                                    required>
                                                                                                    <mat-option
                                                                                                        *ngFor="let status of booleanField"
                                                                                                        [value]="status.value">
                                                                                                        {{status.viewValue}}
                                                                                                    </mat-option>
                                                                                                </mat-select>

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="8" data-th="Weight"
                                                                                            fxLayout.xs="column">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>qty
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-qty' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="qty" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="5" data-th="Image"
                                                                                            fxLayoutAlign="center center">
                                                                                            <button
                                                                                                [attr.guide]="'add-edit-product-btn-13' + '__' + sanitizedUrl"
                                                                                                class="micon"
                                                                                                color="primary"
                                                                                                mat-icon-button>
                                                                                                <mat-icon (click)="addImage(object.value.productVarientGallery
                                                                                ,i)">
                                                                                                    add
                                                                                                </mat-icon>
                                                                                            </button>
                                                                                            <button
                                                                                                [attr.guide]="'add-edit-product-btn-14' + '__' + sanitizedUrl"
                                                                                                (click)="toggle(object)">Expand</button>
                                                                                        </td>

                                                                                    </tr>
                                                                                    <tr fxLayou="row"
                                                                                        *ngIf="object.expanded">



                                                                                        <div fxFlex id="responsieTable"
                                                                                            class="container"
                                                                                            style="overflow: auto;"
                                                                                            formArrayName="productVarientGallery">
                                                                                            <table class="rwd-table">
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <th>Image</th>
                                                                                                        <th>Filename
                                                                                                        </th>
                                                                                                        <th>Position
                                                                                                        </th>
                                                                                                        <th>Action</th>

                                                                                                    </tr>
                                                                                                    <tr *ngFor="let imageValue of object
                                                                                    ['controls']['productVarientGallery']['controls'];
                                                                                     let k = index" [formGroupName]="k">
                                                                                                        <td fxLayout.xs="column"
                                                                                                            data-th="Image">



                                                                                                            <ng-container
                                                                                                                *ngIf="!imageValue.controls.value.value.includes('medicineimages')
                                                                                                                 &&!imageValue.controls.value.value.includes('http')
                                                                                                                 &&!imageValue.controls.value.value.includes('commonimages')
                                                                                                                 &&!imageValue.controls.value.value.includes('external/')
                                                                                                                 &&!isBulkImage(imageValue.controls.value.value)
                                                                                                                 ">

                                                                                                                <calsoft-common-images
                                                                                                                    [src]="serverPath+imageValue.controls.value.value"
                                                                                                                    [height]="'65px'"
                                                                                                                    [width]="'auto'"
                                                                                                                    [alt]="">
                                                                                                                </calsoft-common-images>
                                                                                                            </ng-container>

                                                                                                            <!-- Bulk-imported images: /productId/filename.jpg -->
                                                                                                            <ng-container *ngIf="isBulkImage(imageValue.controls.value.value)">
                                                                                                                <calsoft-common-images
                                                                                                                    [src]="serverPathBulk+imageValue.controls.value.value"
                                                                                                                    [height]="'65px'"
                                                                                                                    [width]="'auto'"
                                                                                                                    [alt]="">
                                                                                                                </calsoft-common-images>
                                                                                                            </ng-container>

                                                                                                            <ng-container
                                                                                                                *ngIf="imageValue.controls.value.value.includes('http')">
                                                                                                                <img style="    height: 65px;
                                                                                            width: auto;" [src]="imageValue.controls.value.value| safe: 'resourceUrl'"
                                                                                                                    onerror="this.src='assets/images/logo/no-image.png';"
                                                                                                                    alt="">

                                                                                                            </ng-container>
                                                                                                            <ng-container
                                                                                                                *ngIf="imageValue.controls.value.value.includes('medicineimages')">

                                                                                                                <calsoft-common-images
                                                                                                                    [src]="serverPath4+imageValue.controls.value.value"
                                                                                                                    [height]="'65px'"
                                                                                                                    [width]="'auto'"
                                                                                                                    [alt]="">

                                                                                                                </calsoft-common-images>
                                                                                                            </ng-container>

                                                                                                            <ng-container
                                                                                                                *ngIf="imageValue.controls.value.value.includes('external/')">

                                                                                                                <calsoft-common-images
                                                                                                                    [src]="serverPath8+imageValue.controls.value.value"
                                                                                                                    [height]="'65px'"
                                                                                                                    [width]="'auto'"
                                                                                                                    [alt]="">

                                                                                                                </calsoft-common-images>
                                                                                                            </ng-container>

                                                                                                            <ng-container
                                                                                                                *ngIf="imageValue.controls.value.value.includes('commonimages')">

                                                                                                                <calsoft-common-images
                                                                                                                    [src]="serverPath7+imageValue.controls.value.value"
                                                                                                                    [height]="'65px'"
                                                                                                                    [width]="'auto'"
                                                                                                                    [alt]="">

                                                                                                                </calsoft-common-images>
                                                                                                            </ng-container>
                                                                                                        </td>
                                                                                                        <td data-th="Filename"
                                                                                                            fxLayout.xs="column">
                                                                                                            {{imageValue.controls.value.value}}

                                                                                                        </td>

                                                                                                        <td data-th="Position"
                                                                                                            fxLayout.xs="column">
                                                                                                            <mat-form-field
                                                                                                                fxFlex>

                                                                                                                <mat-label>
                                                                                                                    Position
                                                                                                                </mat-label>
                                                                                                                <input
                                                                                                                    [attr.guide]="'add-edit-product-inp-position' + '__' + sanitizedUrl"
                                                                                                                    trim="blur"
                                                                                                                    (keydown.enter)="$event.preventDefault()"
                                                                                                                    [autocomplete]="'off'"
                                                                                                                    formControlName="position"
                                                                                                                    numbersOnly
                                                                                                                    matInput />


                                                                                                            </mat-form-field>
                                                                                                        </td>


                                                                                                        <td
                                                                                                            data-th="Action">
                                                                                                            <button
                                                                                                                [attr.guide]="'add-edit-product-btn-15' + '__' + sanitizedUrl"
                                                                                                                color="warn"
                                                                                                                mat-icon-button
                                                                                                                type="button"
                                                                                                                (click)="removeProductVarientGalleryImage(i,k)">
                                                                                                                <mat-icon>
                                                                                                                    remove_circle_outline
                                                                                                                </mat-icon>
                                                                                                            </button>

                                                                                                        </td>

                                                                                                    </tr>

                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </tr>


                                                                                </ng-container>
                                                                        </table>
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Manage Stock Separately
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="maintainStockInd">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>

                                                    </mat-form-field>

                                                </div>

                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Manage Price Separately
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="maintainPriceInd">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>


                                                    </mat-form-field>

                                                </div>

                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Manage Image Separately
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="maintainImageInd">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>


                                                    </mat-form-field>

                                                </div>

                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Enable Filter in Variant 1
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantLabel1Filter">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>


                                                    </mat-form-field>

                                                </div>

                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Enable Filter in Variant 2
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantLabel2Filter">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>



                                            </div>
                                        </div>
                                    </div>


                                    <div *ngIf="groupName =='Booking'" [formGroup]="form">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>Timing (24hr format, leave empty if not avilable full
                                                    day) (Example Format) <b>HH:MM</b> </span>
                                            </div>
                                            <div class="products-padding" fxLayout="column">

                                                <div class="result" fxLayout="column" formArrayName="slots">

                                                    <div *ngFor="let timeObject of   form.get('slots')
                                                    ['controls']; let n=index">
                                                        <div [formGroupName]="n">
                                                            <br>
                                                            <div fxLayout="row" fxLayout.lt-md="column"
                                                                fxLayoutGap="10px">
                                                                <mat-form-field fxFlex="19" appearance="outline">
                                                                    <mat-label>{{timeObject.controls.day.value}}
                                                                    </mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-day' + '__' + sanitizedUrl"
                                                                        readOnly [autocomplete]="'off'" trim="blur"
                                                                        matInput formControlName="day"
                                                                        [disabled]="true" />
                                                                </mat-form-field>
                                                                <mat-form-field fxFlex="19" appearance="outline">
                                                                    <mat-label>Morning Time From</mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-morningtimefrom' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" trim="blur" matInput
                                                                        formControlName="morningTimeFrom" />
                                                                    <mat-error
                                                                        *ngFor="let validation of address_validation_messages.morningTimeFrom">
                                                                        <mat-error class="error-message"
                                                                            *ngIf="timeObject.controls['morningTimeFrom'].hasError(validation.type) && (timeObject.controls['morningTimeFrom'].dirty
                                                                                 || timeObject.controls['morningTimeFrom'].touched)">
                                                                            {{validation.message}}
                                                                        </mat-error>
                                                                    </mat-error>
                                                                </mat-form-field>
                                                                <mat-form-field fxFlex="19" appearance="outline">
                                                                    <mat-label>Morning Time To</mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-morningtimeto' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" trim="blur" matInput
                                                                        formControlName="morningTimeTo" />
                                                                    <mat-error
                                                                        *ngFor="let validation of address_validation_messages.morningTimeTo">
                                                                        <mat-error class="error-message"
                                                                            *ngIf="timeObject.controls['morningTimeTo'].hasError(validation.type) && (timeObject.controls['morningTimeTo'].dirty
                                                                                 || timeObject.controls['morningTimeTo'].touched)">
                                                                            {{validation.message}}
                                                                        </mat-error>
                                                                    </mat-error>
                                                                </mat-form-field>
                                                                <mat-form-field fxFlex="19" appearance="outline">
                                                                    <mat-label>Evening Time From</mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-eveningtimefrom' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" trim="blur" matInput
                                                                        formControlName="eveningTimeFrom" />
                                                                    <mat-error
                                                                        *ngFor="let validation of address_validation_messages.eveningTimeFrom">
                                                                        <mat-error class="error-message"
                                                                            *ngIf="timeObject.controls['eveningTimeFrom'].hasError(validation.type) && (timeObject.controls['morningTimeFrom'].dirty
                                                                                 || timeObject.controls['eveningTimeFrom'].touched)">
                                                                            {{validation.message}}
                                                                        </mat-error>
                                                                    </mat-error>
                                                                </mat-form-field>
                                                                <mat-form-field fxFlex="19" appearance="outline">
                                                                    <mat-label>Evening Time To</mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-eveningtimeto' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" trim="blur" matInput
                                                                        formControlName="eveningTimeTo" />
                                                                    <mat-error
                                                                        *ngFor="let validation of address_validation_messages.eveningTimeTo">
                                                                        <mat-error class="error-message"
                                                                            *ngIf="timeObject.controls['eveningTimeTo'].hasError(validation.type) && (timeObject.controls['eveningTimeTo'].dirty
                                                                                 || timeObject.controls['eveningTimeTo'].touched)">
                                                                            {{validation.message}}
                                                                        </mat-error>
                                                                    </mat-error>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>

                                    </div>

                                    <div *ngIf="groupName =='Course'" [formGroup]="form">

                                        <div class="editSets1">
                                            <div class="title" fxLayout="row" fxLayoutAlign="space-between center">
                                                <span>Course</span>
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-16' + '__' + sanitizedUrl"
                                                    class="micon" color="primary" mat-icon-button (click)="addCourse()">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </div>
                                            <div class="result" fxLayout="column" formArrayName="course">
                                                <div
                                                    *ngFor="let course of form.get('course')['controls']; let i = index">
                                                    <div [formGroupName]="i" class="course-item">
                                                        <div class="products-padding" fxLayout="column">
                                                            <div fxLayout="row" fxLayout.lt-md="column"
                                                                fxLayoutGap="10px">
                                                                <mat-form-field appearance="outline" fxFlex>
                                                                    <mat-label>Title</mat-label>
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-title' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" required trim="blur"
                                                                        matInput formControlName="title" />
                                                                    <mat-error
                                                                        *ngIf="course.controls.title.errors?.required">
                                                                        Please fill out this field.
                                                                    </mat-error>
                                                                </mat-form-field>

                                                                <mat-form-field appearance="outline" fxFlex
                                                                    fxFlex.gt-sm>
                                                                    <mat-label>Active</mat-label>
                                                                    <mat-select [disableOptionCentering]="true"
                                                                        formControlName="active">
                                                                        <mat-option *ngFor="let status of booleanField1"
                                                                            [value]="status.value">
                                                                            {{status.viewValue}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>

                                                                <button
                                                                    [attr.guide]="'add-edit-product-btn-17' + '__' + sanitizedUrl"
                                                                    class="micon" color="primary" mat-icon-button
                                                                    (click)="addCourseItemPopup('Add',i,course.value.courseId,0)">
                                                                    <mat-icon>add</mat-icon>
                                                                </button>

                                                                <!-- Toggle Button - Down Arrow -->
                                                                <button
                                                                    [attr.guide]="'add-edit-product-btn-18' + '__' + sanitizedUrl"
                                                                    mat-icon-button color="primary"
                                                                    (click)="toggleCourseItems(i)">
                                                                    <mat-icon
                                                                        *ngIf="!courseExpanded[i]">keyboard_arrow_down</mat-icon>
                                                                    <mat-icon
                                                                        *ngIf="courseExpanded[i]">keyboard_arrow_right</mat-icon>
                                                                </button>

                                                                <button
                                                                    [attr.guide]="'add-edit-product-btn-19' + '__' + sanitizedUrl"
                                                                    [disabled]="i<1" fxLayoutAlign="center end"
                                                                    mat-icon-button color="warn"
                                                                    (click)="removeOption(i)">
                                                                    <mat-icon>remove</mat-icon>
                                                                </button>
                                                            </div>

                                                            <!-- Expanded Section for Course Items -->
                                                            <div *ngIf="courseExpanded[i]" class="course-items">
                                                                <div formArrayName="courseItem">

                                                                    <div *ngFor="let item of course.get('courseItem')?.controls; let j = index"
                                                                        [formGroupName]="j">
                                                                        <div fxLayout="row" fxLayout.lt-md="column"
                                                                            fxLayoutGap="10px">
                                                                            <mat-form-field appearance="outline" fxFlex>
                                                                                <mat-label>Title</mat-label>
                                                                                <input
                                                                                    [attr.guide]="'add-edit-product-inp-title' + '__' + sanitizedUrl"
                                                                                    [autocomplete]="'off'" trim="blur"
                                                                                    matInput required
                                                                                    formControlName="title" />
                                                                                <mat-error
                                                                                    *ngIf="item.get('title')?.errors?.required">
                                                                                    Please fill out this field.
                                                                                </mat-error>
                                                                            </mat-form-field>

                                                                            <button
                                                                                [attr.guide]="'add-edit-product-btn-20' + '__' + sanitizedUrl"
                                                                                (click)="editCourseItem(item.value,i,j)"
                                                                                class="micon" color="primary"
                                                                                mat-icon-button>
                                                                                <mat-icon>edit</mat-icon>
                                                                            </button>

                                                                            <button
                                                                                [attr.guide]="'add-edit-product-btn-21' + '__' + sanitizedUrl"
                                                                                class="micon" color="primary"
                                                                                (click)="removeCourseItem(i,j)"
                                                                                mat-icon-button>
                                                                                <mat-icon>remove</mat-icon>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div *ngIf="groupName =='Variants Subscription'" [formGroup]="form">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                                <span>Variants Subscription</span>
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-22' + '__' + sanitizedUrl"
                                                    class="micon" color="primary" mat-icon-button>
                                                    <mat-icon (click)="addSubscription()">
                                                        add
                                                    </mat-icon>
                                                </button>
                                            </div>
                                            <div class="products-padding" fxLayout="column">



                                                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center">

                                                    <div id="attribute" fxFlex="100">

                                                        <div class="padding-11" fxFlex="100" style="overflow-x: auto;">
                                                            <div fxFlex="100" class="editSets" fxLayout="column">

                                                                <div fxFlex="100" id="responsieTable" class="container"
                                                                    style="overflow-x:auto;">
                                                                    <div>
                                                                        <table fxFlex="100" class="rwd-table">
                                                                            <tbody fxFlex="100"
                                                                                formArrayName="varientProductItems">
                                                                                <tr>
                                                                                    <th fxFlex="10">Name</th>
                                                                                    <th fxFlex="10">Price</th>
                                                                                    <th fxFlex="10">Special Price</th>
                                                                                    <th fxFlex="10">Sku</th>
                                                                                    <th fxFlex="10">Stock</th>
                                                                                    <th fxFlex="25">Renewal Period</th>
                                                                                    <th fxFlex="25">Type</th>
                                                                                </tr>
                                                                                <ng-container *ngFor="let object of  
                                                                      form.get('varientProductItems')
                                                                      ['controls']; let i=index" [formGroupName]="i">
                                                                                    <tr>
                                                                                        <td data-th="Variant Name"
                                                                                            fxFlex="10">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Name
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-varientname' + '__' + sanitizedUrl"
                                                                                                    readonly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="varientName" />

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="10" data-th="price">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-price' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="price" />

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="10"
                                                                                            data-th="Special Price">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Special Price
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-specialprice' + '__' + sanitizedUrl"
                                                                                                    numbersOnly
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="specialPrice" />
                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="10" data-th="SKU">
                                                                                            <mat-form-field fxFlex="100"
                                                                                                appearance="outline">
                                                                                                <mat-label>Sku
                                                                                                </mat-label>
                                                                                                <input
                                                                                                    [attr.guide]="'add-edit-product-inp-skuid' + '__' + sanitizedUrl"
                                                                                                    [autocomplete]="'off'"
                                                                                                    trim="blur" matInput
                                                                                                    formControlName="skuId" />
                                                                                            </mat-form-field>
                                                                                        </td>

                                                                                        <td fxFlex="10" data-th="Stock">
                                                                                            <mat-form-field
                                                                                                fxLayout="column"
                                                                                                fxFlex="100"
                                                                                                fxFlex.lt-md
                                                                                                appearance="outline">
                                                                                                <mat-label>Is in
                                                                                                    Stock</mat-label>
                                                                                                <mat-select
                                                                                                    [disableOptionCentering]="true"
                                                                                                    formControlName="isInStock"
                                                                                                    required>
                                                                                                    <mat-option
                                                                                                        *ngFor="let status of booleanField"
                                                                                                        [value]="status.value">
                                                                                                        {{status.viewValue}}
                                                                                                    </mat-option>
                                                                                                </mat-select>

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="25"
                                                                                            data-th="Renewal Period">
                                                                                            <mat-form-field
                                                                                                fxLayout="column"
                                                                                                fxFlex="100"
                                                                                                fxFlex.lt-md
                                                                                                appearance="outline">
                                                                                                <mat-label>Renewal
                                                                                                    Period</mat-label>
                                                                                                <mat-select
                                                                                                    [disableOptionCentering]="true"
                                                                                                    formControlName="renewalPeriod"
                                                                                                    required>
                                                                                                    <mat-option
                                                                                                        *ngFor="let status of renewalType"
                                                                                                        [value]="status.value">
                                                                                                        {{status.viewValue}}
                                                                                                    </mat-option>
                                                                                                </mat-select>

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                        <td fxFlex="25" data-th="Type">
                                                                                            <mat-form-field
                                                                                                fxLayout="column"
                                                                                                fxFlex="100"
                                                                                                fxFlex.lt-md
                                                                                                appearance="outline">
                                                                                                <mat-label>Renewal
                                                                                                    Period
                                                                                                    Type</mat-label>
                                                                                                <mat-select
                                                                                                    [disableOptionCentering]="true"
                                                                                                    formControlName="renewalPeriodType"
                                                                                                    required>
                                                                                                    <mat-option
                                                                                                        *ngFor="let status of subscriptionType"
                                                                                                        [value]="status.value">
                                                                                                        {{status.viewValue}}
                                                                                                    </mat-option>
                                                                                                </mat-select>

                                                                                            </mat-form-field>
                                                                                        </td>
                                                                                    </tr>

                                                                                </ng-container>
                                                                        </table>
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>


                                                <!-- <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Manage Stock Separately
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="maintainStockInd">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>

                                                    </mat-form-field>

                                                </div> -->

                                                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap.gt-sm="24px"
                                                    formGroupName="variant">

                                                    <mat-form-field appearance="outline" fxFlex="100%" fxFlex.gt-sm>
                                                        <mat-label>Manage Price Separately
                                                        </mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="maintainPriceInd">
                                                            <mat-option *ngFor="let item  of booleanField1"
                                                                [value]="item.value">
                                                                {{item .viewValue}}
                                                            </mat-option>
                                                        </mat-select>


                                                    </mat-form-field>

                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                    <!-- Related Products -->
                                    <div (click)="restritionPopup('related')" *ngIf="groupName =='Related Products'">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>Related Products </span>
                                            </div>
                                            <div class="products-padding" [ngClass]="{ overlayProduct:relatedSell }"
                                                fxLayout="column">

                                                <div fxFlex="60" fxLayout="column" fxLayout.gt-sm="row"
                                                    fxLayoutAlign="space-between center">
                                                    <p>
                                                        Related products are shown to customers in addition
                                                        to the item the customer is looking at.
                                                    </p>

                                                    <button
                                                        [attr.guide]="'add-edit-product-btn-23' + '__' + sanitizedUrl"
                                                        fxFlex="40" mat-raised-button
                                                        (click)="productLinkPopup(1,'Related Products')">
                                                        Add Related Products
                                                    </button>
                                                </div>

                                                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center"
                                                    *ngIf="(relatedProducts?.length || 0) > 0">

                                                    <div id="attribute" fxFlex="100">

                                                        <div class="padding-11">
                                                            <div class="editSets" fxLayout="column">


                                                                <div id="responsieTable" class="container">
                                                                    <div
                                                                        [ngClass]="(relatedProducts?.length || 0) >= 5 ? 'minimum' : 'none'">
                                                                        <table class="rwd-table">
                                                                            <tbody>
                                                                                <tr>

                                                                                    <th>Name</th>
                                                                                    <th>SKU</th>

                                                                                    <th>Price</th>

                                                                                    <th>Action</th>

                                                                                </tr>


                                                                                <tr
                                                                                    *ngFor="let productObject of relatedProducts;let i=index">

                                                                                    <td data-th="name">
                                                                                        {{productObject.name |
                                                                                        slice:0:40}}
                                                                                    </td>
                                                                                    <td data-th="sku">
                                                                                        {{productObject.sku }}
                                                                                    </td>
                                                                                    <td data-th="price">
                                                                                        {{productObject.price }}
                                                                                    </td>

                                                                                    <td data-th="Action">
                                                                                        <button
                                                                                            [attr.guide]="'add-edit-product-btn-24' + '__' + sanitizedUrl"
                                                                                            mat-icon-button color="warn"
                                                                                            (click)="removeLinkedProduct(i,productObject)">
                                                                                            <mat-icon>
                                                                                                remove
                                                                                            </mat-icon>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <div fxLayout="row" class="products-padding"
                                                                            *ngIf="(relatedProducts?.length || 0) == 0"
                                                                            fxLayoutAlign="center center">
                                                                            <span>No Records Found</span>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                    <!-- Up Sell Products -->
                                    <div (click)="restritionPopup('upsell')" *ngIf="groupName =='Up-Sells'">
                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>Up-Sells Products</span>
                                            </div>
                                            <div class="products-padding" [ngClass]="{ overlayProduct:upSell }"
                                                fxLayout="column">

                                                <div fxFlex="60" fxLayout="column" fxLayout.gt-sm="row"
                                                    fxLayoutAlign="space-between center">
                                                    <p>
                                                        An up-sell item is offered to the customer as a pricier or
                                                        higher-quality alternative to the product the customer is
                                                        looking at.
                                                    </p>

                                                    <button
                                                        [attr.guide]="'add-edit-product-btn-25' + '__' + sanitizedUrl"
                                                        fxFlex="40" mat-raised-button
                                                        (click)="productLinkPopup(4,'Up-Sells Products')">
                                                        Add Up-Sells Products
                                                    </button>
                                                </div>

                                                <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between center"
                                                    *ngIf="(upSellsProduct?.length || 0) > 0">

                                                    <div id="attribute" fxFlex="100">

                                                        <div class="padding-11" style="overflow-x: auto;">
                                                            <div class="editSets" fxLayout="column">


                                                                <div id="responsieTable" class="container">
                                                                    <div
                                                                        [ngClass]="(upSellsProduct?.length || 0) >= 5 ? 'minimum' : 'none'">
                                                                        <table class="rwd-table">
                                                                            <tbody>
                                                                                <tr>

                                                                                    <th>Name</th>
                                                                                    <th>SKU</th>

                                                                                    <th>Price</th>

                                                                                    <th>Action</th>

                                                                                </tr>


                                                                                <tr
                                                                                    *ngFor="let productObject of upSellsProduct;let i=index">

                                                                                    <td data-th="name">
                                                                                        {{productObject.name |
                                                                                        slice:0:40}}
                                                                                    </td>
                                                                                    <td data-th="sku">
                                                                                        {{productObject.sku }}
                                                                                    </td>
                                                                                    <td data-th="price">
                                                                                        {{productObject.price }}
                                                                                    </td>

                                                                                    <td data-th="Action">
                                                                                        <button
                                                                                            [attr.guide]="'add-edit-product-btn-26' + '__' + sanitizedUrl"
                                                                                            mat-icon-button color="warn"
                                                                                            (click)="removeLinkedProduct(i,productObject)">
                                                                                            <mat-icon>
                                                                                                remove
                                                                                            </mat-icon>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <div fxLayout="row" class="products-padding"
                                                                            *ngIf="(upSellsProduct?.length || 0) == 0"
                                                                            fxLayoutAlign="center center">
                                                                            <span>No Records Found</span>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!-- Cross-Sells Products -->
                                    <div *ngIf="groupName =='Cross-Sells'">
                                        <div [ngClass]="{ 'overlayProduct': crossSell }"
                                            (click)="restritionPopup('crosssell')">
                                            <div class="editSets1">
                                                <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                    <span> Cross-Sells Products</span>
                                                </div>
                                                <div class="products-padding" fxLayout="column">

                                                    <div fxFlex="60" fxLayout="column" fxLayout.gt-sm="row"
                                                        fxLayoutAlign="space-between center">
                                                        <p>
                                                            These "impulse-buy" products appear next to the shopping
                                                            cart as
                                                            cross-sells to the items already in the shopping cart.
                                                        </p>

                                                        <button
                                                            [attr.guide]="'add-edit-product-btn-27' + '__' + sanitizedUrl"
                                                            fxFlex="40" mat-raised-button
                                                            (click)="productLinkPopup(5,'Cross-Sells Products')">
                                                            Add Cross-Sells Products
                                                        </button>
                                                    </div>

                                                    <div fxLayout="row" fxFlex="100"
                                                        fxLayoutAlign="space-between center"
                                                        *ngIf="(crossSellsProduct?.length || 0) > 0">

                                                        <div id="attribute" fxFlex="100">

                                                            <div class="padding-11" style="overflow-x: auto;">
                                                                <div class="editSets" fxLayout="column">


                                                                    <div id="responsieTable" class="container">
                                                                        <div
                                                                            [ngClass]="(crossSellsProduct?.length || 0) >= 5 ? 'minimum' : 'none'">
                                                                            <table class="rwd-table">
                                                                                <tbody>
                                                                                    <tr>

                                                                                        <th>Name</th>
                                                                                        <th>SKU</th>

                                                                                        <th>Price</th>

                                                                                        <th>Action</th>

                                                                                    </tr>


                                                                                    <tr
                                                                                        *ngFor="let productObject of crossSellsProduct;let i=index">

                                                                                        <td data-th="name">
                                                                                            {{productObject.name |
                                                                                            slice:0:40}}
                                                                                        </td>
                                                                                        <td data-th="sku">
                                                                                            {{productObject.sku }}
                                                                                        </td>
                                                                                        <td data-th="price">
                                                                                            {{productObject.price }}
                                                                                        </td>

                                                                                        <td data-th="Action">
                                                                                            <button
                                                                                                [attr.guide]="'add-edit-product-btn-28' + '__' + sanitizedUrl"
                                                                                                mat-icon-button
                                                                                                color="warn"
                                                                                                (click)="removeLinkedProduct(i,productObject)">
                                                                                                <mat-icon>
                                                                                                    remove
                                                                                                </mat-icon>
                                                                                            </button>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                            <div fxLayout="row" class="products-padding"
                                                                                *ngIf="(crossSellsProduct?.length || 0) == 0"
                                                                                fxLayoutAlign="center center">
                                                                                <span>No Records Found</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>


                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end of Configurations -->

                                    <!-- images -->

                                    <div *ngIf="groupName =='Images'" class="editSets">
                                        <div fxLayout="column" class="title-head3" color="primary">
                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                <span>Image </span>
                                                <div fxLayoutGap="10px">
                                                    <button
                                                        [attr.guide]="'add-edit-product-btn-29' + '__' + sanitizedUrl"
                                                        (click)="openDialog()">
                                                        <mat-icon>add</mat-icon>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>



                                        <div id="responsieTable" class="container" style="overflow: auto;">
                                            <table class="rwd-table">
                                                <tbody>
                                                    <tr>
                                                        <th>Image</th>
                                                        <th>Filename</th>
                                                        <th>Position</th>
                                                        <th>Action</th>

                                                    </tr>
                                                    <tr *ngFor="let ImageInfo of mediaGallery; let i = index">
                                                        <td data-th="Image">
                                                            <ng-container *ngIf="ImageInfo.value.includes('http')">

                                                                <img style="height: 65px;
                                                            width: auto;" [src]="ImageInfo.value| safe: 'resourceUrl'"
                                                                    onerror="this.src='assets/images/logo/no-image.png';"
                                                                    alt="">

                                                            </ng-container>
                                                            <ng-container
                                                                *ngIf="ImageInfo.value.includes('commonimages/')">
                                                                <calsoft-common-images
                                                                    [src]="serverPath7+ImageInfo.value"
                                                                    [height]="'65px'" [width]="'auto'" [alt]="">

                                                                </calsoft-common-images>
                                                            </ng-container>

                                                            <ng-container *ngIf="ImageInfo.value.includes('external/')">
                                                                <calsoft-common-images
                                                                    [src]="serverPath8+ImageInfo.value"
                                                                    [height]="'65px'" [width]="'auto'" [alt]="">

                                                                </calsoft-common-images>
                                                            </ng-container>

                                                            <ng-container *ngIf="!ImageInfo.value.includes('medicineimages')
                                                                &&!ImageInfo.value.includes('http') 
                                                                &&!ImageInfo.value.includes('external/') 
                                                                &&!ImageInfo.value.includes('commonimages/')
                                                                &&!isBulkImage(ImageInfo.value)"
                                                            >

                                                                <calsoft-common-images
                                                                    [src]="serverPath+ImageInfo.value" [height]="'65px'"
                                                                    [width]="'auto'" [alt]="">

                                                                </calsoft-common-images>

                                                            </ng-container>

                                                            <!-- Bulk-imported images: /productId/filename.jpg -->
                                                            <ng-container *ngIf="isBulkImage(ImageInfo.value)">
                                                                <calsoft-common-images
                                                                    [src]="serverPathBulk+ImageInfo.value" [height]="'65px'"
                                                                    [width]="'auto'" [alt]="">
                                                                </calsoft-common-images>
                                                            </ng-container>

                                                            <ng-container
                                                                *ngIf="ImageInfo.value.includes('medicineimages')">

                                                                <calsoft-common-images
                                                                    [src]="serverPath4+ImageInfo.value"
                                                                    [height]="'65px'" [width]="'auto'" [alt]="">

                                                                </calsoft-common-images>
                                                            </ng-container>

                                                        </td>
                                                        <td data-th="Filename" class="filename-td">
                                                            <span class="filename-content">
                                                                {{ImageInfo.value}}
                                                            </span>
                                                        </td>

                                                        <td data-th="Position">
                                                            <mat-form-field fxFlex>

                                                                <mat-label>Position</mat-label>
                                                                <input
                                                                    [attr.guide]="'add-edit-product-inp-30' + '__' + sanitizedUrl"
                                                                    trim="blur"
                                                                    (keydown.enter)="$event.preventDefault()"
                                                                    [autocomplete]="'off'"
                                                                    [(ngModel)]="ImageInfo.productEntityMediaGalleryValue.position"
                                                                    required numbersOnly matInput />

                                                            </mat-form-field>
                                                        </td>

                                                        <td data-th="Action">
                                                            <button
                                                                [attr.guide]="'add-edit-product-btn-31' + '__' + sanitizedUrl"
                                                                [disabled]="(mediaGallery?.length || 0) <= 1 && productId > 0"
                                                                color="warn" mat-icon-button type="button"
                                                                (click)="deleteImage(ImageInfo.value,i)">
                                                                <mat-icon>remove_circle_outline
                                                                </mat-icon>
                                                            </button>

                                                        </td>

                                                    </tr>

                                                </tbody>
                                            </table>
                                        </div>

                                        <div class="padding-l10" fxLayout="column">
                                            <span *ngIf="(mediaGallery?.length || 0) <= 0" fxLayoutAlign="center center">No
                                                Images
                                                Uploaded</span>
                                            <calsoft-file-upload (fileUploadResult)=getResult($event)
                                                [productId]="productId" [type]="'multi'">
                                            </calsoft-file-upload>
                                        </div>

                                    </div>
                                    <!-- end of images -->

                                    <!-- category -->

                                    <div fxLayout="column" fxLayoutGap="10px" *ngIf="groupName =='Categories'">

                                        <div fxLayout="row">
                                            <div fxFlex class="editSets">
                                                <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                                    <span>Category Navigation</span>
                                                </div>
                                                <div style="padding-left: 10px;"
                                                    *ngFor="let item of form.value.catalogCategoryProduct">

                                                    <calsoft-cat-navigation [categoryId]="item.categoryId"
                                                        [type]="'category'"></calsoft-cat-navigation>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="editSets1">
                                            <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                <span>Categories</span>
                                            </div>
                                            <div class="products-padding" fxLayout="column">

                                                <ng-template #recursiveList let-list>
                                                    <div *ngFor="let item of list" class="menu-item">

                                                        <a mat-button fxLayout="row" fxLayoutAlign="start center"
                                                            [id]="'menu-item-'+item.categoryId">

                                                            <div fxLayout="row"
                                                                [ngClass]="item.parentId!=2 ?'subCatpadding':'none'"
                                                                fxLayoutAlign="start center" fxLayoutGap="10px"
                                                                id="custom-checkbox">
                                                                <!-- <div *ngIf="item.parentId!=2">
                                                                    <mat-icon
                                                                        style="padding-bottom: 40px;color: #dddddd;">
                                                                        horizontal_rule</mat-icon>
                                                                </div> -->
                                                                <div (change)="selected($event,item.categoryId)"
                                                                    class="md-checkbox ">
                                                                    <input
                                                                        [attr.guide]="'add-edit-product-inp-32' + '__' + sanitizedUrl"
                                                                        [autocomplete]="'off'" [id]="item.categoryId"
                                                                        type="checkbox"
                                                                        [disabled]="firstFormGroup.value.parentId== item.categoryId"
                                                                        [checked]="selection.indexOf(item.categoryId) >= 0"
                                                                        [value]="item.categoryId">
                                                                    <label
                                                                        [for]="item.categoryId">{{item.categoryName}}</label>
                                                                </div>
                                                            </div>
                                                            <mat-icon
                                                                *ngIf="item.subcategories && item.subcategories.length"
                                                                (click)="toggleMenuItem(item.categoryId)"
                                                                class="menu-expand-icon transition-2">
                                                                arrow_drop_down</mat-icon>
                                                        </a>
                                                        <div class="sub-menu" [id]="'sub-menu-'+item.categoryId"
                                                            *ngIf="item.subcategories && item.subcategories.length > 0">
                                                            <ng-container *ngTemplateOutlet="recursiveList; context:
                                                                { $implicit: item.subcategories }">
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                                <ng-container
                                                    *ngTemplateOutlet="recursiveList; context:{ $implicit: list }">
                                                </ng-container>

                                            </div>
                                        </div>
                                    </div>
                                    <!-- end of Category -->



                                    <ng-template #variantImage>
                                        <div [formGroup]="form">
                                            <div class="padding-10 color-gray font-white-color">
                                                <span>Add Or Remove Image</span>
                                            </div>


                                            <div id="responsieTable" class="container">
                                                <div [ngClass]="(mediaGallery?.length || 0) >= 5 ? 'minimum' : 'none'">
                                                    <table class="rwd-table">
                                                        <tbody>
                                                            <tr>
                                                                <th>ACTION </th>
                                                                <th>Image</th>
                                                                <th>Filename</th>

                                                            </tr>
                                                            <tr *ngFor="let ImageInfo of mediaGallery; let i = index">
                                                                <td data-th="Action">
                                                                    <mat-checkbox
                                                                        [attr.guide]="'add-edit-product-chk-33' + '__' + sanitizedUrl"
                                                                        [checked]="imageAdded.indexOf(ImageInfo.value) >= 0"
                                                                        (change)="onChangeImage(ImageInfo, $event.checked)">

                                                                    </mat-checkbox>
                                                                </td>
                                                                <td data-th="Image">

                                                                    <ng-container *ngIf="!ImageInfo.value.includes('medicineimages')
                                                                        &&!ImageInfo.value.includes('http')
                                                                        &&!ImageInfo.value.includes('external/')
                                                                        &&!ImageInfo.value.includes('commonimages')
                                                                        &&!isBulkImage(ImageInfo.value)">
                                                                        <calsoft-common-images
                                                                            [src]="serverPath+ImageInfo.value"
                                                                            [height]="'65px'" [width]="'auto'" [alt]="">

                                                                        </calsoft-common-images>
                                                                    </ng-container>

                                                                    <!-- Bulk-imported images: /productId/filename.jpg -->
                                                                    <ng-container *ngIf="isBulkImage(ImageInfo.value)">
                                                                        <calsoft-common-images
                                                                            [src]="serverPathBulk+ImageInfo.value"
                                                                            [height]="'65px'" [width]="'auto'" [alt]="">
                                                                        </calsoft-common-images>
                                                                    </ng-container>

                                                                    <ng-container
                                                                        *ngIf="ImageInfo.value.includes('http')">
                                                                        <img style="height: 65px; width: auto;"
                                                                            [src]="ImageInfo.value| safe: 'resourceUrl'"
                                                                            onerror="this.src='assets/images/logo/no-image.png';"
                                                                            alt="">
                                                                    </ng-container>
                                                                    <ng-container
                                                                        *ngIf="ImageInfo.value.includes('medicineimages')">

                                                                        <calsoft-common-images
                                                                            [src]="serverPath4+ImageInfo.value"
                                                                            [height]="'65px'" [width]="'auto'" [alt]="">

                                                                        </calsoft-common-images>
                                                                    </ng-container>

                                                                    <ng-container
                                                                        *ngIf="ImageInfo.value.includes('commonimages/')">

                                                                        <calsoft-common-images
                                                                            [src]="serverPath7+ImageInfo.value"
                                                                            [height]="'65px'" [width]="'auto'" [alt]="">

                                                                        </calsoft-common-images>
                                                                    </ng-container>


                                                                    <ng-container
                                                                        *ngIf="ImageInfo.value.includes('external/')">

                                                                        <calsoft-common-images
                                                                            [src]="serverPath8+ImageInfo.value"
                                                                            [height]="'65px'" [width]="'auto'" [alt]="">

                                                                        </calsoft-common-images>
                                                                    </ng-container>
                                                                </td>
                                                                <td data-th="Filename">
                                                                    {{ImageInfo.value}}

                                                                </td>

                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>



                                            <div class="padding-10" fxLayoutAlign="end center" fxLayoutGap="10px">
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-34' + '__' + sanitizedUrl"
                                                    mat-raised-button (click)="close()">Cancel</button>
                                                <button
                                                    [attr.guide]="'add-edit-product-btn-35' + '__' + sanitizedUrl"
                                                    [disabled]="textAccount !='OK'"
                                                    (click)=" addImageToProductVarientGallery()" mat-raised-button>
                                                    {{textAccount}}
                                                    <mat-icon *ngIf="textAccount !='OK' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>

                                        </div>


                                    </ng-template>

                                    <ng-template #variantInformation>
                                        <div [formGroup]="form">

                                            <div class="padding-10 color-gray font-white-color">
                                                <span>Add Variant</span>
                                            </div>
                                            <!-- <perfect-scrollbar style=" max-width: 1000px;max-height: 500px;"
                                                class="scroll"> -->
                                            <div class="padding-10">


                                                <div fxLayout="row" formGroupName="variant" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">


                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Variant Name -1</mat-label>
                                                        <input
                                                            [attr.guide]="'add-edit-product-inp-variantlabel1' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="variantLabel1" />

                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline" fxFlex fxFlex.gt-sm>
                                                        <mat-label>Configuration Type For Variant 1</mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantType1">
                                                            <mat-option *ngFor="let status of configTypeList"
                                                                [value]="status.value">
                                                                {{status.viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>


                                                </div>
                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                                    <mat-form-field fxFlex class="example-chip-list">
                                                        <mat-chip-list #chipList>
                                                            <mat-chip *ngFor="let variantObject of variants1"
                                                                [removable]="removable"
                                                                (removed)="remove(variantObject,'variants1')">
                                                                {{variantObject}}
                                                                <mat-icon matChipRemove *ngIf="removable">cancel
                                                                </mat-icon>
                                                            </mat-chip>
                                                            <input
                                                                [attr.guide]="'add-edit-product-inp-36' + '__' + sanitizedUrl"
                                                                (input)="onInput($event)" [matChipInputFor]="chipList"
                                                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                                [matChipInputAddOnBlur]="addOnBlur"
                                                                (matChipInputTokenEnd)="add($event,'variants1')" />
                                                        </mat-chip-list>
                                                    </mat-form-field>




                                                </div>




                                                <div formGroupName="variant" fxLayout="row" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">


                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Variant Name -2</mat-label>
                                                        <input
                                                            [attr.guide]="'add-edit-product-inp-variantlabel2' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="variantLabel2" />


                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" fxFlex fxFlex.gt-sm>
                                                        <mat-label>Configuration Type For Variant 2</mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantType2">
                                                            <mat-option *ngFor="let status of configTypeList"
                                                                [value]="status.value">
                                                                {{status.viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>

                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                                    <mat-form-field fxFlex class="example-chip-list">
                                                        <mat-chip-list #chipList1>
                                                            <mat-chip *ngFor="let variantObject2 of variants2"
                                                                [selectable]="selectable" [removable]="removable"
                                                                (removed)="remove(variantObject2,'variants2')">
                                                                {{variantObject2}}
                                                                <mat-icon matChipRemove *ngIf="removable">cancel
                                                                </mat-icon>
                                                            </mat-chip>
                                                            <input
                                                                [attr.guide]="'add-edit-product-inp-37' + '__' + sanitizedUrl"
                                                                (input)="onInput($event)" [matChipInputFor]="chipList1"
                                                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                                [matChipInputAddOnBlur]="addOnBlur"
                                                                (matChipInputTokenEnd)="add($event,'variants2')" />
                                                        </mat-chip-list>
                                                    </mat-form-field>


                                                </div>



                                            </div>
                                            <!-- </perfect-scrollbar> -->

                                            <div class="padding-10" fxLayoutAlign="end center" fxLayoutGap="10px">

                                                <button
                                                    [attr.guide]="'add-edit-product-btn-38' + '__' + sanitizedUrl"
                                                    [disabled]="textAccount !='OK'" (click)="addVariant()"
                                                    mat-raised-button>
                                                    {{textAccount}}
                                                    <mat-icon *ngIf="textAccount !='OK' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>

                                        </div>
                                    </ng-template>

                                    <ng-template #variantSubscription>
                                        <div [formGroup]="form">

                                            <div class="padding-10 color-gray font-white-color">
                                                <span>Add Subscription</span>
                                            </div>
                                            <div class="padding-10">


                                                <div fxLayout="row" formGroupName="variant" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">


                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Name</mat-label>
                                                        <input
                                                            [attr.guide]="'add-edit-product-inp-variantlabel1' + '__' + sanitizedUrl"
                                                            [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="variantLabel1" />

                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline" fxFlex fxFlex.gt-sm>
                                                        <mat-label>Configuration Type For Variant 1</mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantType1">
                                                            <mat-option *ngFor="let status of configTypeList"
                                                                [value]="status.value">
                                                                {{status.viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>


                                                </div>
                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                                    <mat-form-field fxFlex class="example-chip-list">
                                                        <mat-chip-list #chipList>
                                                            <mat-chip *ngFor="let variantObject of variants1"
                                                                [removable]="removable"
                                                                (removed)="remove(variantObject,'variants1')">
                                                                {{variantObject}}
                                                                <mat-icon matChipRemove *ngIf="removable">cancel
                                                                </mat-icon>
                                                            </mat-chip>
                                                            <input
                                                                [attr.guide]="'add-edit-product-inp-39' + '__' + sanitizedUrl"
                                                                (input)="onInput($event)" [matChipInputFor]="chipList"
                                                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                                [matChipInputAddOnBlur]="addOnBlur"
                                                                (matChipInputTokenEnd)="add($event,'variants1')" />
                                                        </mat-chip-list>
                                                    </mat-form-field>




                                                </div>




                                                <!-- <div formGroupName="variant" fxLayout="row" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">


                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Variant Name -2</mat-label>
                                                        <input [attr.guide]="'add-edit-product-inp-variantlabel2' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="variantLabel2"/>


                                                    </mat-form-field>
                                                    <mat-form-field appearance="outline" fxFlex fxFlex.gt-sm>
                                                        <mat-label>Configuration Type For Variant 2</mat-label>
                                                        <mat-select [disableOptionCentering]="true"
                                                            formControlName="variantType2">
                                                            <mat-option *ngFor="let status of configTypeList"
                                                                [value]="status.value">
                                                                {{status.viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>

                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                                                    <mat-form-field fxFlex class="example-chip-list">
                                                        <mat-chip-list #chipList1>
                                                            <mat-chip *ngFor="let variantObject2 of variants2"
                                                                [selectable]="selectable" [removable]="removable"
                                                                (removed)="remove(variantObject2,'variants2')">
                                                                {{variantObject2}}
                                                                <mat-icon matChipRemove *ngIf="removable">cancel
                                                                </mat-icon>
                                                            </mat-chip>
                                                            <input [attr.guide]="'add-edit-product-inp-40' + '__' + sanitizedUrl" (input)="onInput($event)"
                                                                [matChipInputFor]="chipList1"
                                                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                                [matChipInputAddOnBlur]="addOnBlur"
                                                                (matChipInputTokenEnd)="add($event,'variants2')"/>
                                                        </mat-chip-list>
                                                    </mat-form-field>


                                                </div> -->



                                            </div>
                                            <!-- </perfect-scrollbar> -->

                                            <div class="padding-10" fxLayoutAlign="end center" fxLayoutGap="10px">

                                                <button
                                                    [attr.guide]="'add-edit-product-btn-41' + '__' + sanitizedUrl"
                                                    [disabled]="textAccount !='OK'" (click)="addVariant()"
                                                    mat-raised-button>
                                                    {{textAccount}}
                                                    <mat-icon *ngIf="textAccount !='OK' ">
                                                        <mat-spinner color="primary" diameter="20">
                                                        </mat-spinner>
                                                    </mat-icon>
                                                </button>
                                            </div>

                                        </div>
                                    </ng-template>
                                </ng-container>
                            </calsoft-scrollbar>
                        </div>
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>

<ng-template #download>

    <div class="index-head">
        <span>Download</span>
    </div>

    <form [formGroup]="secondFormGroup">
        <div class="padding-10">

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Image Link</mat-label>
                    <input [attr.guide]="'add-edit-product-inp-imagelink' + '__' + sanitizedUrl" matInput
                        formControlName="imageLink" required />
                    <mat-error *ngIf="secondFormGroup.controls.imageLink.errors?.required">
                        Please fill out this field.
                    </mat-error>
                    <mat-error *ngIf="secondFormGroup.controls.imageLink.errors?.pattern">
                        Enter a valid format.
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'add-edit-product-btn-42' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'add-edit-product-btn-43' + '__' + sanitizedUrl" [disabled]="textAccount !='OK'"
            (click)=" submit1()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='OK' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #special>

    <div class="index-head">
        <span>Special Discount in Percent</span>
    </div>

    <form [formGroup]="thirdFormGroup">
        <div class="padding-10">

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Special Price Discount</mat-label>
                    <input [attr.guide]="'add-edit-product-inp-specialdiscount' + '__' + sanitizedUrl" matInput
                        formControlName="specialDiscount" />
                </mat-form-field>
            </div>
        </div>
    </form>
    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'add-edit-product-btn-44' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'add-edit-product-btn-45' + '__' + sanitizedUrl" [disabled]="textAccount !='OK'"
            (click)=" submit2()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='OK' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #coursePopup>
    <div [formGroup]="courseForm">

        <div class="padding-10 color-gray font-white-color">
            <span>Add Course Details</span>
        </div>

        <div class="padding-10">

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field appearance="outline" fxFlex="50">
                    <mat-label>Title</mat-label>
                    <input [attr.guide]="'add-edit-product-inp-title' + '__' + sanitizedUrl" required
                        [autocomplete]="'off'" trim="blur" matInput formControlName="title" />
                    <mat-error *ngIf="courseForm.controls.title.errors?.required">
                        Please fill out this field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex="50">
                    <mat-label>Active</mat-label>
                    <mat-select [disableOptionCentering]="true" formControlName="active">
                        <mat-option *ngFor="let status of booleanField1" [value]="status.value">
                            {{status.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Type</mat-label>
                    <mat-select (selectionChange)="setCourseType($event.value)" [disableOptionCentering]="true"
                        formControlName="type">
                        <mat-option *ngFor="let status of fileType" [value]="status.value">
                            {{status.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Free Preview</mat-label>
                    <mat-select [disableOptionCentering]="true" formControlName="freePreview">
                        <mat-option *ngFor="let status of booleanField2" [value]="status.value">
                            {{status.viewValue}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>



                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Description</mat-label>
                    <input [attr.guide]="'add-edit-product-inp-customfield1' + '__' + sanitizedUrl"
                        [autocomplete]="'off'" trim="blur" matInput formControlName="customField1" />

                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                <div *ngIf="courseForm.value.type==2">
                    <calsoft-course-pdf-upload fxFlex="100" [finalValue]="courseForm.value.value"
                        (sendValue)="getValue($event)"></calsoft-course-pdf-upload>
                </div>

                <div *ngIf="courseForm.value.type==1">
                    <calsoft-video-upload fxFlex="100" [finalValue]="courseForm.value.value"
                        (sendValue)="getValue($event)">
                    </calsoft-video-upload>

                </div>

                <div *ngIf="courseForm.value.type==8 ">
                    <calsoft-audio-upload fxFlex="100" [finalValue]="courseForm.value.value"
                        (sendValue)="getValue($event)">

                    </calsoft-audio-upload>
                </div>

                <div fxFlex="50" *ngIf="courseForm.value.type==6">
                    <mat-form-field appearance="outline" fxFlex="100">
                        <mat-label>Url</mat-label>
                        <input [attr.guide]="'add-edit-product-inp-value' + '__' + sanitizedUrl"
                            [autocomplete]="'off'" trim="blur" matInput formControlName="value" />

                    </mat-form-field>
                </div>

                <div *ngIf="courseForm.value.type==3">
                    <calsoft-image fxFlex="100" [finalValue]="courseForm.value.value" (sendValue)="getValue($event)">
                    </calsoft-image>

                </div>


            </div>


            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field *ngIf="courseForm.value.type==7" fxFlex="50" appearance="outline">
                    <mat-label>Value</mat-label>
                    <textarea [attr.guide]="'add-edit-product-sel-value' + '__' + sanitizedUrl" trim="blur"
                        matTextareaAutosize matAutosizeMinRows=1 matAutosizeMaxRows=5 matInput
                        formControlName="value"></textarea>
                    <mat-icon class="clickable" (click)="openEditorText(courseForm.value.value)" matSuffix>
                        post_add
                    </mat-icon>
                    <mat-hint fxHide.lt-md>Click on the icon to open editor</mat-hint>
                </mat-form-field>
            </div>

            <div *ngIf="courseForm.value.type==9" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field fxFlex appearance="outline">
                    <mat-label>Quiz Form</mat-label>
                    <mat-select formControlName="value" [disableOptionCentering]="true" #singleSelect name="item">
                        <mat-option>
                            <ngx-mat-select-search name="Quiz Form Search" ngDefaultControl [formControl]="
                  dynamicFormFilterControl
                    " placeholderLabel="Quiz Form Search" [preventHomeEndKeyPropagation]="
                      true
                    " noEntriesFoundLabel="No data found">
                            </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let opt of filtereddynamicFormTypeList;" [value]="opt.formGroupId">
                            {{ opt.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
                <mat-form-field *ngIf="courseForm.value.type==1 || courseForm.value.type==8" fxFlex="50"
                    appearance="outline">
                    <mat-label>Duration</mat-label>
                    <input [attr.guide]="'add-edit-product-inp-courseduration' + '__' + sanitizedUrl" numbersOnly
                        [required]="courseForm.value.type==1 || courseForm.value.type==8" [autocomplete]="'off'"
                        trim="blur" matInput formControlName="courseDuration" />
                    <mat-error *ngIf="courseForm.controls.courseDuration.errors?.required">
                        Please fill out this field.
                    </mat-error>

                    <mat-hint fxHide.lt-md>Enter duration in seconds</mat-hint>
                </mat-form-field>
            </div>
        </div>


        <div class="padding-10" fxLayoutAlign="end center" fxLayoutGap="10px">
            <button [attr.guide]="'add-edit-product-btn-46' + '__' + sanitizedUrl" class="clrbg"
                matDialogClose="yes" mat-raised-button>
                Cancel
            </button>

            <button [attr.guide]="'add-edit-product-btn-47' + '__' + sanitizedUrl" (click)="setCourseItem()"
                mat-raised-button>
                Ok

            </button>
        </div>

    </div>
</ng-template>